import React, { useEffect, useMemo, useRef } from 'react'

import {
  Box,
  Button,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  withStyles,
} from '@material-ui/core'
import BaseCreatePage from '../../../../components/hooks/BaseCreatePage'
import {
  StyledCelBodyCSV,
  StyledCellHeaderCSV,
  useStyles,
} from '../../../service-type/pages/import/styles/baseStyles'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { mdiCloudDownload, mdiContentCopy } from '@mdi/js'
import Icon from '@mdi/react'

import colors from '../../../../assets/colors'
import { csvTableFormat } from './fields/csv'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { downloadImportTemplate, importClients } from '../../ClientActions'

export const ImportClients = props => {
  const dispatch = useDispatch()
  const history = useHistory()
  const inputRef = useRef()

  const filterStyles = filterStylesComponents()
  const styles = useStyles()

  const [file, setFile] = useState(null)
  const [simulated, setSimulated] = useState(false)
  const [erros, setErrors] = useState(false)

  const onClose = () => {
    history.goBack()
  }

  const handleDownloadTemplate = () => {
    dispatch(downloadImportTemplate())
  }

  const handleClickInput = () => {
    inputRef.current.click()
  }

  const handleChooseFile = e => {
    e.preventDefault()

    const { files } = e.target

    const file = files ? files[0] : null

    setSimulated(false)
    setErrors(null)
    setFile(file)
  }

  const handleSubmit = async simulate => {
    if (!file) return

    const formData = new FormData()
    formData.append('file', file)
    formData.append('simulate', simulate)
    const resp = await dispatch(importClients(formData))

    if (resp?.response?.data?.failures) {
      setFile(null)
      return setErrors(resp?.response?.data?.failures)
    }

    if (resp?.data?.message) {
      if (!simulated) return setSimulated(true)

      if (simulated && !simulate) {
        setSimulated(false)
        setErrors(null)
        setFile(null)
        return onClose()
      }
    }
  }

  return (
    <BaseCreatePage path={'Importar'} page={'Clientes'} goBack hiddenReturn>
      <Grid item xs={12}>
        <Grid container>
          <Box className={styles.container}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container>
                  <Box className={styles.subContainer}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Grid
                          container
                          alignItems="center"
                          justifyContent="center"
                          direction="column"
                          spacing={2}
                        >
                          <Grid item>
                            <Typography className={styles.simpleText}>
                              Utilize o arquivo de exemplo para gerar o arquivo
                              que será importado.
                            </Typography>
                          </Grid>
                          <Grid item>
                            <IconButton
                              className={styles.downloadBtn}
                              onClick={handleDownloadTemplate}
                            >
                              <Icon path={mdiCloudDownload} size={1.5} />
                            </IconButton>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <BaseCreatePage
                              page={'INSTRUÇÕES CSV'}
                              path={'CADASTRO'}
                              hiddenReturn
                              xs
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TableContainer className={styles.tableContainer}>
                              <Table size="small" aria-label="a dense table">
                                <TableHead>
                                  <TableRow>
                                    <StyledCellHeaderCSV />
                                    <StyledCellHeaderCSV align="center">
                                      Obrigatório
                                    </StyledCellHeaderCSV>
                                    <StyledCellHeaderCSV align="center">
                                      Info. Adicionais
                                    </StyledCellHeaderCSV>
                                    <StyledCellHeaderCSV align="center">
                                      Valores
                                    </StyledCellHeaderCSV>
                                    <StyledCellHeaderCSV align="center">
                                      Formato
                                    </StyledCellHeaderCSV>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {csvTableFormat?.map(row => (
                                    <TableRow key={row.name}>
                                      <StyledCelBodyCSV
                                        style={{
                                          borderRight: '1px solid',
                                          borderColor: colors.graylight,
                                        }}
                                      >
                                        {row.row}
                                      </StyledCelBodyCSV>
                                      <StyledCelBodyCSV
                                        align="center"
                                        style={{
                                          borderRight: '1px solid',
                                          borderColor: colors.graylight,
                                        }}
                                      >
                                        {row.required ? 'Sim' : 'Não'}
                                      </StyledCelBodyCSV>
                                      <StyledCelBodyCSV
                                        align="center"
                                        style={{
                                          borderRight: '1px solid',
                                          borderColor: colors.graylight,
                                        }}
                                      >
                                        {row.additional_information}
                                      </StyledCelBodyCSV>
                                      <StyledCelBodyCSV
                                        align="center"
                                        style={{
                                          borderRight: '1px solid',
                                          borderColor: colors.graylight,
                                        }}
                                      >
                                        {row.values}
                                      </StyledCelBodyCSV>
                                      <StyledCelBodyCSV align="center">
                                        {row.format}
                                      </StyledCelBodyCSV>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <Grid container spacing={1}>
                          <Grid item xs={12}>
                            <Typography className={styles.simpleText}>
                              Os campos que não aparecem aqui, não são
                              obrigatórios
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <Typography className={styles.simpleText}>
                              *Você só pode importar depois de simular
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Button
                  fullWidth
                  className={styles.importBtn}
                  onClick={handleClickInput}
                  type="button"
                >
                  <Grid container direction="column">
                    <Grid item xs>
                      <Typography>Arquivo csv</Typography>
                    </Grid>

                    <Grid item xs>
                      {file && <Typography>{file?.name}</Typography>}
                    </Grid>
                  </Grid>
                </Button>
                <input
                  ref={inputRef}
                  type="file"
                  accept=".xlsx"
                  style={{ visibility: 'hidden' }}
                  onChange={handleChooseFile}
                  key={`input-file-${file?.name}`}
                />
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  {Array.isArray(erros) &&
                    erros?.map(error => (
                      <>
                        <Grid item xs={12}>
                          <Grid container spacing={1}>
                            <Grid item>
                              <Typography style={{ color: colors.error }}>
                                Erro na linha: {error?.row}{' '}
                                <ul>
                                  {error?.errors?.map(e => (
                                    <li>{e}</li>
                                  ))}
                                </ul>
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </>
                    ))}
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Box className={filterStyles.areaButtons}>
                  <IconButton
                    className={filterStyles.btnMoreFilters}
                    onClick={onClose}
                  >
                    Cancelar
                  </IconButton>

                  <IconButton
                    className={filterStyles.btnAdd}
                    onClick={() => handleSubmit(true)}
                  >
                    <Icon path={mdiContentCopy} size={1} />
                    Simular
                  </IconButton>

                  <IconButton
                    className={filterStyles.btnSalvar}
                    onClick={() => handleSubmit(false)}
                    disabled={!simulated}
                  >
                    Importar
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </BaseCreatePage>
  )
}
